export const messageHost = (event: string, origin: string = '*', data = {}) => {
  window.parent.postMessage({
    event,
    data,
  }, '*');
}
